import { Button } from '../../../../../design-system/button/button';
import { Inline } from '../../../../../design-system/inline/inline';
import { Stack } from '../../../../../design-system/stack/stack';
import { getSortingVariantContent } from './utils/get-sorting-variant-content';

const sortingOptions = [
  'CONFIDENCE_SCORE_LOW_TO_HIGH',
  'CONFIDENCE_SCORE_HIGH_TO_LOW',
  'DATE_OLD_TO_NEW',
  'DATE_NEW_TO_OLD',
] as const;

export type SortingVariant = (typeof sortingOptions)[number];

type TableSortingContentProps = {
  onSelectSortingOption: (sorting: SortingVariant) => void;
};

export const TableSortingContent = ({ onSelectSortingOption }: TableSortingContentProps) => {
  return (
    <Stack align="stretch" className="py-4">
      <h4 className="px-5 text-xs font-medium leading-5 tracking-tight text-seapoint-gray-text">Sort by</h4>

      {sortingOptions.map((o) => {
        const { label, text, icon: Icon } = getSortingVariantContent(o);

        return (
          <Button
            key={o}
            variant="ghost"
            size="none"
            className="rounded-none px-5 py-1 hover:bg-seapoint-yellow/20"
            aria-label={`Sort by ${label} ${text}`}
            onClick={() => {
              onSelectSortingOption(o);
            }}
          >
            <Inline justify="between" className="w-full">
              <p className="text-sm font-normal leading-6 tracking-tight text-black">{label}</p>

              <Inline space={1}>
                <p className="text-sm font-normal leading-6 tracking-tight text-seapoint-gray-text">{text}</p>

                <div className="h-4 w-4 text-seapoint-gray-text">
                  <Icon className="h-full w-full" />
                </div>
              </Inline>
            </Inline>
          </Button>
        );
      })}
    </Stack>
  );
};
